const constant = {
    CAN_ADD_MORE_DUE_DATES: process.env.enable_todo_more_duedates,
    FILE_UPLOAD_URL: "/Todo/FileUpload",
    DIARY_PRIORITY_OPTIONS: [
        {
            label: "High",
            value: 'high'
        },
        {
            label: "Normal",
            value: "normal"
        },
        {
            label: "Low",
            value: "low"
        },
    ],
    FORM_NAME : 'diaryCreation',
}

export default constant;